import { makeStyles } from "tss-react/mui";

const useStyle = makeStyles()((theme) => ({
  // ── Not Connected Card ────────────────────────────────────────────────
  cardWrapper: {
    position: "relative",
    padding: "36px 40px",
    textAlign: "center",
    backgroundColor: "rgba(255, 255, 255, 0.75)",
    backdropFilter: "blur(12px) saturate(130%)",
    border: "1px solid rgba(0, 0, 0, 0.06)",
    boxShadow: "0 2px 16px rgba(0, 0, 0, 0.04)",
    overflow: "hidden",
    transition:
      "padding 0.45s cubic-bezier(0.4, 0, 0.2, 1), border-radius 0.45s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.45s ease, box-shadow 0.45s ease",
    "&.collapsed": {
      padding: "14px 24px",
      backgroundColor: "rgba(255, 255, 255, 0.99)",
      boxShadow: "0 1px 8px rgba(0, 0, 0, 0.06)",
    },
  },
  contentBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "18px",
    position: "relative",
    zIndex: 1,
    transition: "flex-direction 0.3s ease, gap 0.3s ease",
    "&.collapsed": {
      flexDirection: "row",
      alignItems: "center",
      gap: "20px",
    },
  },
  iconContainer: {
    width: "64px",
    height: "64px",
    borderRadius: "16px",
    backgroundColor: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 12px rgba(24, 119, 242, 0.10)",
    padding: "12px",
    flexShrink: 0,
    transition:
      "width 0.4s ease, height 0.4s ease, border-radius 0.4s ease, padding 0.4s ease",
    "&.collapsed": {
      width: "40px",
      height: "40px",
      borderRadius: "10px",
      padding: "8px",
    },
  },
  fbIcon: {
    height: "100%",
    width: "100%",
    objectFit: "contain",
  },
  mainTitle: {
    fontFamily: "Poppins",
    fontWeight: "700",
    fontSize: "22px",
    color: "#1a1a1a",
    margin: 0,
    letterSpacing: "-0.3px",
    transition: "font-size 0.3s ease, opacity 0.3s ease",
    "&.collapsed": {
      fontSize: "17px",
      fontWeight: "600",
    },
  },
  description: {
    fontFamily: "Poppins",
    fontSize: "13.5px",
    color: "#666",
    maxWidth: "420px",
    lineHeight: "1.65",
    fontWeight: "400",
    margin: 0,
    transition: "opacity 0.25s ease, max-height 0.35s ease",
    "&.collapsed": {
      display: "none",
    },
  },
  connectBtn: {
    backgroundColor: "#1877F2",
    borderRadius: "10px",
    padding: "10px 32px",
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "14px",
    color: "#fff",
    textTransform: "none",
    transition:
      "padding 0.35s ease, font-size 0.35s ease, border-radius 0.35s ease, box-shadow 0.2s ease, background-color 0.2s ease",
    boxShadow: "none",
    "&.collapsed": {
      padding: "7px 20px",
      fontSize: "13px",
      borderRadius: "8px",
    },
    "&:hover": {
      backgroundColor: "#145dbf",
      boxShadow: "0 4px 16px rgba(24, 119, 242, 0.25)",
    },
    "&:active": {
      transform: "scale(0.98)",
    },
  },
  howItWorksBtn: {
    textTransform: "none",
    fontFamily: "Poppins",
    fontSize: "13px",
    color: "#4D1277",
    fontWeight: "500",
    opacity: 0.75,
    transition: "opacity 0.2s",
    "&:hover": {
      backgroundColor: "transparent",
      opacity: 1,
    },
  },

  // ── Connected Box ─────────────────────────────────────────────────────
  rootConnectedBox: {
    backgroundColor: "rgba(255, 255, 255, 0.75)",
    backdropFilter: "blur(12px)",
    borderRadius: "18px",
    padding: "20px 28px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: "20px",
    border: "1px solid rgba(0, 0, 0, 0.06)",
    boxShadow: "0 2px 16px rgba(0, 0, 0, 0.04)",
    position: "relative",
    transition:
      "padding 0.4s ease, border-radius 0.4s ease, background-color 0.4s ease",
    "&.collapsed": {
      padding: "12px 20px",
      borderRadius: "14px",
      backgroundColor: "rgba(255, 255, 255, 0.95)",
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      padding: "24px 20px",
      gap: "16px",
    },
  },
  avatar: {
    height: "52px",
    width: "52px",
    borderRadius: "14px",
    border: "2px solid rgba(0,0,0,0.06)",
    flexShrink: 0,
    transition: "height 0.4s ease, width 0.4s ease, border-radius 0.4s ease",
    "&.collapsed": {
      height: "36px",
      width: "36px",
      borderRadius: "10px",
    },
  },
  userName: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "17px",
    color: "#1a1a1a",
    margin: 0,
    flex: 1,
    textAlign: "left",
    transition: "font-size 0.3s ease",
    "&.collapsed": {
      fontSize: "14px",
    },
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  actionGroup: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      flexDirection: "column",
      gap: "10px",
    },
  },
  DisconnectButton: {
    borderRadius: "10px",
    padding: "8px 20px",
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "13.5px",
    color: "#E34D59",
    border: "1px solid rgba(227, 77, 89, 0.2)",
    backgroundColor: "transparent",
    textTransform: "none",
    transition: "background-color 0.2s, border-color 0.2s",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: "10px 0",
    },
    "&:hover": {
      backgroundColor: "rgba(227, 77, 89, 0.05)",
      borderColor: "rgba(227, 77, 89, 0.4)",
      color: "#E34D59",
    },
  },
  labelAddButton: {
    borderRadius: "10px",
    backgroundColor: "#4D1277",
    padding: "8px 20px",
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "13.5px",
    color: "#fff",
    textTransform: "none",
    boxShadow: "none",
    transition: "background-color 0.2s, box-shadow 0.2s",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: "10px 0",
    },
    "&:hover": {
      backgroundColor: "#3a0d5a",
      boxShadow: "0 4px 12px rgba(77, 18, 119, 0.2)",
    },
  },
  labelAddIcon: {
    fontSize: "18px !important",
  },

  // ── Error Box ─────────────────────────────────────────────────────────
  pagesAddingErrorBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 20px",
    background: "#FED7D7",
    borderRadius: "12px",
    border: "1px solid rgba(227, 77, 89, 0.12)",
  },
  errorTextStyle: {
    fontFamily: "Poppins",
    fontSize: "13px",
    color: "#E34D59",
    fontWeight: "500",
  },
  clearIconStyle: {
    cursor: "pointer",
    color: "#E34D59",
    opacity: 0.5,
    "&:hover": {
      opacity: 1,
    },
  },

  // ── Legacy / kept for compatibility ───────────────────────────────────
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    gap: "5px",
  },
  fbText: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "18px",
    color: "#000000",
  },
  fbAccConnectBtn: {
    backgroundColor: "#1877F2",
    borderRadius: "6px",
    padding: "8px 10px",
    "&:hover": {
      backgroundColor: "#145dbf",
      boxShadow: "none",
    },
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "16px",
    color: "#fff",
    boxShadow: "none",
  },
  modalStyleClass: {
    marginTop: "5px",
    textTransform: "capitalize",
    width: "100%",
    fontSize: "14px",
  },
  circularProgress: {
    marginLeft: "5px",
    "& svg": {
      width: "17px",
      height: "17px",
      color: "white",
    },
  },
  pagesErrorInternalTextBox: {
    display: "flex",
    gap: "5px",
    alignItems: "center",
    width: "100%",
  },
  cardContent: {
    padding: 0,
    margin: 0,
  },
  upperCompStyle: {
    marginBottom: "16px",
  },
}));

export default useStyle;
